import { colors } from '../../constants';
const MuiOutlinedInput = {
  root: {
    'label + &': {
      marginTop: 20
    },
    borderRadius: 5,
    '&$disabled $notchedOutline': {
      border: 'none'
    },
    '&$disabled': {
      backgroundColor: colors.oriGrey[100]
    },
    '&$focused $notchedOutline': {
      borderWidth: 1
    },
    '&:hover $notchedOutline': {
      borderColor: colors.text.disabled
    }
  },
  input: {
    padding: '15px 15px'
  },
  notchedOutline: {
    top: 0,
    background: 'unset',
    '& legend': {
      maxWidth: 0
    }
  },
  multiline: {
    padding: '15px 25px 15px 15px'
  }
};
export default MuiOutlinedInput;